<!--Old UI without doctor note audio-->
<div *ngIf="!showNewUI" class="tw-bg-teal-700 tw-px-4 tw-pt-6 tw-pb-8" (click)="openNutraBottomSheet()">
<!--  heading -->
  <div class="tw-flex tw-mb-4">
    <img class="tw-w-6 tw-aspect-square" src="/assets/gifs/white-lightning-dar-teal-bg.gif" />
    <!-- Face heading (shown when FACE is present, which covers both FACE only and FACE+HAIR cases) -->
    <div *ngIf="regimensClass?.includes('FACE')" class="tw-text-500 tw-font-bold tw-text-white tw-font-lexend">
      <ng-container [ngSwitch]="nutraPushBottomSheetData?.margId">
        <h1 *ngSwitchCase="'A00211'" i18n="@@getGlowingEvenTonedSkin">Get Glowing, Even-Toned Skin</h1>
        <h1 *ngSwitchCase="'A00194'" i18n="@@forBrighterEvenSkin">For brighter &amp; even skin</h1>
        <h1 *ngSwitchCase="'A00210'" i18n="@@forGlowingFirmYouthful">For Glowing, Firm, Youthful Skin</h1>
        <h1 *ngSwitchCase="'A00212'" i18n="@@achieveClearerStringerSkin">Achieve Clearer, Stronger Skin</h1>
        <h1 *ngSwitchDefault i18n="@@getGlowingEvenTonedSkin">Get Glowing, Even-Toned Skin</h1>
      </ng-container>
    </div>
    <!-- Hair heading (shown only when HAIR is present and FACE is not) -->
    <div *ngIf="!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR')" class="tw-text-500 tw-font-bold tw-text-white tw-font-lexend">
      <ng-container [ngSwitch]="nutraPushBottomSheetData?.margId">
        <h1 *ngSwitchCase="'A00211'" i18n="@@getGlowingEvenTonedSkin">Get Glowing, Even-Toned Skin</h1>
        <h1 *ngSwitchCase="'A00194'" i18n="@@forStrongerHealthierHair">For Stronger, Healthier Hair</h1>
        <h1 *ngSwitchCase="'A00210'" i18n="@@forStrongerRootsFullerHair">Get Stronger Roots, Fuller Hair</h1>
        <h1 *ngSwitchCase="'A00212'" i18n="@@strongerRootsHealthierScalp">Stronger Roots, Healthier Scalp</h1>
        <h1 *ngSwitchDefault i18n="@@forStrongerHealthierHair">For Stronger, Healthier Hair</h1>
      </ng-container>
    </div>
  </div>
<!--  Nutra Banner Container-->
    <div class="tw-flex tw-w-full tw-rounded-3 tw-overflow-hidden tw-bg-gradient-white-to-gray">

      <div class="tw-w-full tw-pt-[22px] tw-pb-5">
        <div class="tw-max-w-[155px] tw-ml-4 tw-mb-4">
          <h1 class="tw-text-500 tw-text-bold tw-font-lexend tw-mb-1">{{nutraPushBottomSheetData?.title}}</h1>
          <!-- Face sub title (shown when FACE is present, which covers both FACE only and FACE+HAIR cases) -->
          <div *ngIf="regimensClass?.includes('FACE')" class="tw-text-200 tw-text-gray-750 tw-font-medium tw-leading-[14px]">
            <ng-container [ngSwitch]="nutraPushBottomSheetData?.margId">
              <p *ngSwitchCase="'A00211'" i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
              <p *ngSwitchCase="'A00194'" i18n="@@myoPushBannerFaceSubTitle">2 out of 3 users achieved clearer skin, reduced acne</p>
              <p *ngSwitchCase="'A00210'" i18n="@@vitalPushBannerFaceSubTitle">A powerful blend of Biotin, Amino Acids, Vitamins &amp; Minerals</p>
              <p *ngSwitchCase="'A00212'" i18n="@@omegaPushBannerFaceSubTitle">Say goodbye to flare-ups, breakouts and dryness</p>
              <p *ngSwitchDefault i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
            </ng-container>
          </div>
          <!-- Hair sub title (shown only when HAIR is present and FACE is not) -->
          <div *ngIf="!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR')" class="tw-text-200 tw-text-gray-750 tw-font-medium tw-leading-[14px]">
            <ng-container [ngSwitch]="nutraPushBottomSheetData?.margId">
              <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.GLUTA" i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
              <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO" i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
              <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.VITAL" i18n="@@vitalPushBannerHairSubTitle">Daily nourishment for your hair from the inside out</p>
              <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA" i18n="@@omegaPushBannerHairSubTitle">When your scalp is balanced and nourished, great hair follows</p>
              <p *ngSwitchDefault i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
            </ng-container>
          </div>
        </div>

        <div class="tw-ml-4 tw-text-300 tw-font-bold tw-text-white tw-bg-teal-600 tw-w-fit tw-py-2 tw-px-4 tw-rounded-2 tw-leading-[16px]" i18n="@@knowMore">Know More</div>
      </div>
      <div class="tw-w-[165px] tw-flex-shrink-0 tw-flex tw-justify-end tw-items-end">
            <img class="tw-w-[165px]" [src]="nutraPushBannerData?.coverImage" />
      </div>

    </div>
</div>

<!--New UI with doctor note audio-->
<div *ngIf="showNewUI" class="tw-px-4 tw-py-5 tw-bg-white" (click)="openNutraBottomSheet()">
<!--  heading  -->
  <div class="tw-flex tw-gap-2 tw-items-center tw-mb-4">
    <img alt="icon" src="/assets/icons/orange_tick_new.svg" class="tw-w-4 tw-aspect-square">
    <h1 class="tw-uppercase tw-tracking-[1.5px] tw-font-medium tw-font-body" i18n="@@recommendedByYourDoctor">Recommended by your doctor</h1>
  </div>

<!--  card  -->
  <div class="tw-w-full tw-rounded-3 tw-bg-gradient-white-to-gray tw-relative tw-min-h-[192px] tw-flex tw-flex-col tw-justify-between">
<!--text content-->
    <div class="tw-pl-4 tw-pb-4"
         [ngClass]="{ 'tw-pt-[17px] lg:tw-pt-[27px]': nutraPushBottomSheetData?.margId === appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA, 'tw-pt-[27px]': nutraPushBottomSheetData?.margId != appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA,  }"
    >
      <div class="tw-w-[calc(100%-140px)] sm:tw-pr-1 lg:tw-pr-4">
        <h1 class="tw-text-[clamp(1.33rem,4vw,2rem)] tw-font-[700] tw-font-lexend tw-mb-2">{{ nutraPushBottomSheetData?.margId === appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO ? nutraPushBannerData?.title : nutraPushBottomSheetData?.title}}</h1>
        <!-- Face sub title (shown when FACE is present, which covers both FACE only and FACE+HAIR cases) -->
        <div *ngIf="regimensClass?.includes('FACE')" class="tw-text-[clamp(0.835rem,3vw,1rem)] tw-text-gray-750 tw-font-medium tw-line-clamp-2 tw-text-ellipsis">
          <ng-container [ngSwitch]="nutraPushBottomSheetData?.margId">
            <p *ngSwitchCase="'A00211'" i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
            <p *ngSwitchCase="'A00194'" i18n="@@myoPushBannerFaceSubTitle">2 out of 3 users achieved clearer skin, reduced acne</p>
            <p *ngSwitchCase="'A00210'" i18n="@@vitalPushBannerFaceSubTitle">A powerful blend of Biotin, Amino Acids, Vitamins &amp; Minerals</p>
            <p *ngSwitchCase="'A00212'" i18n="@@omegaPushBannerFaceSubTitle">Say goodbye to flare-ups, breakouts and dryness</p>
            <p *ngSwitchDefault i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
          </ng-container>
        </div>
        <!-- Hair sub title (shown only when HAIR is present and FACE is not) -->
        <div *ngIf="!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR')" class="tw-text-[clamp(0.835rem,3vw,1rem)] tw-text-gray-750 tw-font-medium tw-leading-4 tw-line-clamp-2 tw-text-ellipsis">
          <ng-container [ngSwitch]="nutraPushBottomSheetData?.margId">
            <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.GLUTA" i18n="@@glutaPushBannerSubTitle">86% users achieved even skin tone &amp; glow with 3 months of consistent use</p>
            <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.MYO" i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
            <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.VITAL" i18n="@@vitalPushBannerHairSubTitle">Daily nourishment for your hair from the inside out</p>
            <p *ngSwitchCase="appConfig.Shared.NUTRA_PRODUCT_MARG_IDS.OMEGA" i18n="@@omegaPushBannerHairSubTitle">When your scalp is balanced and nourished, great hair follows</p>
            <p *ngSwitchDefault i18n="@@myoPushBannerHairSubTitle">3 out of 5 noticed stronger hair &amp; lesser hair fall</p>
          </ng-container>
        </div>
      </div>
      <p class="tw-font-[700] tw-text-teal-600 tw-text-[clamp(0.835rem,3vw,1rem)] tw-leading-4 tw-lowercase first-letter:tw-uppercase" i18n="@@knowMore">Know More</p>
    </div>
<!--    audio -->
    <div class="tw-px-4 tw-w-full tw-pb-3 tw-relative tw-z-[2]">
      <div class="tw-rounded-full tw-overflow-hidden">
        <ng-container *ngIf="regimensClass?.includes('FACE') && !!drFaceAudioNote">
                  <c-audio [newUI]=true [src]="drFaceAudioNote"
                           [imageUrl]="drInfo?.imageUrl" [eventPrefix]="'nutra_push_face'" ></c-audio>
        </ng-container>

        <ng-container *ngIf="!regimensClass?.includes('FACE') && regimensClass?.includes('HAIR') && !!drHairAudioNote">
          <c-audio [newUI]=true [src]="drHairAudioNote"
                   [imageUrl]="drInfo?.imageUrl" [eventPrefix]="'nutra_push_hair'"></c-audio>
        </ng-container>
      </div>
    </div>
    <!--    bg image  -->
    <div class="tw-absolute tw-z-[1] tw-bottom-0 tw-right-0 tw-w-max tw-flex-shrink-0 tw-flex tw-justify-end tw-items-end">
      <img class="tw-rounded-3 tw-h-[192px]" [src]="nutraPushBannerData?.coverImageV2" id="nutra product">
    </div>
  </div>
</div>
